module.exports = __webpack_public_path__ + "img/icon-question-rating-group-heart.cbfdf6df.svg";